import { debounce } from "lodash"
import flattenObject from "./FlattenObject"


const updateFilters = debounce((filters, configurations, navigate, location, setFilterValues) => {
    let visibleFilters = configurations.filter(item => item.showFilter).map(item => item.name)
    let newFilterValues = {}

    Object.keys(filters).map(key => {
        if (visibleFilters.includes(key) || key === "searchTerm")
            newFilterValues[key] = filters[key]
    })

    newFilterValues = flattenObject(newFilterValues)

    // Rebuild the URL starting from the CURRENT search string rather than
    // from scratch. This module only knows about this page's legacy filter
    // configurations, but other query params can legitimately coexist --
    // most notably the Advanced Filters `?filter=` param (base64 filter
    // state, see Filters/filterUrl.js) and deep-link params like `task_id`.
    // Only params this module actually manages (the visible filters plus
    // `searchTerm`) are cleared/overwritten here; everything else survives.
    const managedNames = new Set([...visibleFilters, "searchTerm"])
    const params = new URLSearchParams(location.search)
    const existingKeys = [...params.keys()]
    existingKeys.forEach(key => {
        const baseName = key.split(".")[0]
        if (managedNames.has(baseName)) {
            params.delete(key)
        }
    })
    Object.entries(newFilterValues).forEach(([key, value]) => {
        params.set(key, value)
    })

    navigate({
        pathname: location.pathname,
        hash: location.hash,
        search: params.toString(),
    })
    setFilterValues({ ...filters })

}, 1000)

export default updateFilters
